import { z } from 'zod';

// Streaming responses are typically Blob/ReadableStream types
// For type safety, we use z.unknown() as they're handled specially in Next.js
export const StreamResponseSchema = z.unknown();
